/**
 * CardForm
 * provide link and ask user to provide token from Trello
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormGroup, Checkbox, ControlLabel, FormControl, Button } from 'react-bootstrap';
import TrelloLabel from './TrelloLabel';
import IconButton from './IconButton';

const CollapsedWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  button {
    margin-top: -12px;
  }
`;

const ListBase = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  & > * {
    white-space: nowrap;
    overflow: hidden;
    line-height: 2.2rem;
    text-overflow: ellipsis;
    flex: 0 0 calc(33.33% - 12px);
  }
`;

const CollapsedList = ListBase.withComponent(FormGroup).extend`
    @media (min-width: 480px) {
      margin-left: 10rem;
    }
    & > :not(.pull-right) {
      font-size: 1.2rem;
      margin-right: 10px;
      margin-bottom: 8px;
      &:not([color]) {
        border: 1px solid #ccc;
        padding: 0 8px;
        border-radius: 3px;
      }
      @media (min-width: 480px) {
        flex-basis: auto;
      }
    }
`;

const CheckboxesWrapper = ListBase.extend`
  & > * {
    margin-left: 10px;
    font-size: 1.3rem;
    padding-top: 8px;
    @media (min-width: 480px) {
      flex-basis: 14rem;
    }

  }
`;

class CardForm extends React.PureComponent {
  state = {
    name: '',
    desc: '',
    labels: arrayToObject(this.props.storage.labels),
    members: arrayToObject(this.props.storage.members),
    collapsed: true,
  };

  handleChange = this.handleChange.bind(this)

  handleChange(key) {
    return (ev) => {
      const { type, value, checked } = ev.target;
      if (type !== 'checkbox') {
        this.setState({ [key]: value });
        return;
      }
      this.setState((prevState) => ({ [key]: { ...prevState[key], [value]: checked } }));
    };
  }

  handleSubmit = this.handleSubmit.bind(this)

  handleSubmit(ev) {
    ev.preventDefault();
    const {
      name, desc, labels, members,
    } = this.state;
    const { onSubmit } = this.props;
    const result = {
      name,
      desc,
      labels: objectToArray(labels),
      members: objectToArray(members),
    };
    this.setState({ collapsed: true });
    onSubmit(result);
  }

  expand = this.expand.bind(this);

  expand() {
    this.setState({ collapsed: false });
  }

  render() {
    const { options, status } = this.props;
    const {
      name, desc, labels, members, collapsed,
    } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <FormGroup controlId="name">
          <ControlLabel>Name</ControlLabel>
          <FormControl
            type="text"
            value={name}
            required
            autoFocus
            onChange={this.handleChange('name')}
          />
        </FormGroup>
        <FormGroup controlId="desc">
          <ControlLabel>Description</ControlLabel>
          <FormControl
            componentClass="textarea"
            value={desc}
            onChange={this.handleChange('desc')}
          />
        </FormGroup>
        {collapsed && (
          <CollapsedWrapper>
            <CollapsedList>
              {options.labels && options.labels.map((label) => Boolean(labels[label.id]) &&
                <TrelloLabel key={label.id} label={label} />)}
              {options.members && options.members.map((member) => Boolean(members[member.id]) &&
                <div key={member.id}>{member.name}</div>)}
            </CollapsedList>
            <IconButton icon="pencil2" className="pull-right" onClick={this.expand} />
          </CollapsedWrapper>
        )}
        {!collapsed && options.labels &&
        <FormGroup controlId="labels">
          <ControlLabel>Labels</ControlLabel>
          <CheckboxesWrapper>
            {options.labels.map((label) => (
              <Checkbox
                inline
                key={label.id}
                value={label.id}
                title={label.name}
                checked={Boolean(labels[label.id])}
                onChange={this.handleChange('labels')}
              >
                <TrelloLabel label={label} />
              </Checkbox>
            ))}
          </CheckboxesWrapper>
        </FormGroup>
        }
        {!collapsed && options.members &&
        <FormGroup controlId="members">
          <ControlLabel>Members</ControlLabel>
          <CheckboxesWrapper>
            {options.members.map((member) => (
              <Checkbox
                inline
                key={member.id}
                value={member.id}
                title={member.name}
                checked={Boolean(members[member.id])}
                onChange={this.handleChange('members')}
              >
                {member.name}
              </Checkbox>
            ))}
          </CheckboxesWrapper>
        </FormGroup>
        }
        <FormGroup className="submit-group">
          <Button type="submit" disabled={status.working} bsStyle="primary">Submit</Button>
        </FormGroup>
      </form>
    );
  }
}

CardForm.propTypes = {
  storage: PropTypes.object,
  options: PropTypes.object,
  status: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default CardForm;

function objectToArray(obj) {
  const keys = Object.keys(obj);
  return keys.filter((key) => obj[key]);
}

function arrayToObject(arr) {
  if (!arr) {
    return {};
  }
  return arr.reduce((acc, key) => ({ ...acc, [key]: true }), {});
}



// WEBPACK FOOTER //
// ./src/components/CardForm.js